import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const tiers = [{
  name: 'Wayfinder',
  price: 'Free',
  description: 'For casual explorers',
  features: ['25 pins', '1 fieldbook', 'Basic terrain view', 'Community atlas access'],
  cta: 'Begin Wayfinding',
  highlight: false
}, {
  name: 'Pathkeeper',
  price: '€9',
  period: '/month',
  description: 'For serious travelers',
  features: ['Unlimited pins', '10 fieldbooks', 'Full terrain & elevation data', 'Route planning', 'Export to GPX'],
  cta: 'Keep the Path',
  highlight: true,
  badge: 'Most Popular'
}, {
  name: 'Cartographer',
  price: '€29',
  period: '/month',
  description: 'For professionals',
  features: ['Everything in Pathkeeper', 'API access to Meridian Tools', 'Custom map styles', 'Team expeditions', 'Priority geo-data updates'],
  cta: 'Chart Everything',
  highlight: false
}];
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-parchment-dark relative" data-id="element-174">
      <div className="absolute inset-0 bg-paper-texture opacity-30" data-id="element-175" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-176">
        <div className="text-center mb-16" data-id="element-177">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-forest mb-4" data-id="element-178">
            Choose Your Expedition
          </h2>
          <div className="w-24 h-1 bg-terracotta mx-auto rounded-full" data-id="element-179" />
        </div>

        <div className="grid md:grid-cols-3 gap-8 items-start" data-id="element-180">
          {tiers.map((tier, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} viewport={{
          once: true
        }} className={`relative bg-parchment rounded-sm p-8 border-2 ${tier.highlight ? 'border-terracotta shadow-xl scale-105 z-10' : 'border-brown/20 shadow-md'}`} data-id="element-181">
              {tier.highlight && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-terracotta text-parchment px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider shadow-sm" data-id="element-182">
                  {tier.badge}
                </div>}

              <div className="text-center mb-8" data-id="element-183">
                <h3 className="text-2xl font-serif font-bold text-forest mb-2" data-id="element-184">
                  {tier.name}
                </h3>
                <div className="flex items-baseline justify-center text-forest" data-id="element-185">
                  <span className="text-4xl font-bold" data-id="element-186">{tier.price}</span>
                  {tier.period && <span className="text-forest/60 ml-1" data-id="element-187">{tier.period}</span>}
                </div>
                <p className="text-forest/60 mt-2 text-sm uppercase tracking-wide" data-id="element-188">
                  {tier.description}
                </p>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-189">
                {tier.features.map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-190">
                    <Check className="w-5 h-5 text-sage mr-3 flex-shrink-0 mt-0.5" data-id="element-191" />
                    <span className="text-forest/80 text-sm" data-id="element-192">{feature}</span>
                  </li>)}
              </ul>

              <button className={`w-full py-3 px-6 rounded-sm font-serif font-bold transition-all duration-300 ${tier.highlight ? 'bg-terracotta text-parchment hover:bg-terracotta-hover shadow-md' : 'bg-forest/10 text-forest hover:bg-forest/20'}`} data-id="element-193">
                {tier.cta}
              </button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}